/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { CSVLink } from 'react-csv'
import { TbChartInfographic, TbPigMoney } from 'react-icons/tb'
import { useQuery } from 'react-query'
import styled from 'styled-components'
import { color, Container, Content, Title } from '../../../GlobalStyle'
import apiPdv from '../../../hooks/API_PDV'
import { groupByMonth } from '../../../hooks/GroupSales'
import { Mask } from '../../../hooks/Mask'
import BoxShadow from '../../components/BoxShadowDiv'
import PieChart from '../Report2/chart'
import LineChart from './chart'
import ColumnHighChart from './ColumnChart'
import { GridLayout, Infos } from './style'

// const Table = styled.table`
//   border-collapse: collapse;
//   width: 100%;

//   th:last-of-type,
//   td:last-of-type {
//     text-align: right;
//   }
// `

const Th = styled.th`
  text-align: left;
  padding: 12px 8px;
  color: #575757;
  border-bottom: 1px solid #b2b2b2;
`

const Td = styled.td`
  border-bottom: 1px solid #dddddd;
  text-align: left;
  padding: 12px 8px;
`

const Tr = styled.tr``

const StyledCSVLink = styled(CSVLink)`
  display: inline-block;
  margin-bottom: 10px;
  padding: 12px 20px;
  background-color: ${color.brand};
  text-decoration: none;
  color: #fff;
  font-weight: bold;
  border-radius: 3px;
`

const Report1 = () => {
  const [dataPassed, setData] = useState([])
  const [tableSales, setTableSales] = useState([])
  const { data: salesData, isLoading } = useQuery(['sales'], () => apiPdv.getSales())

  function reduceSales(data) {
    return data?.reduce((acc, obj) => {
      const date = new Date(obj.data)
      const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${date.getFullYear()}`
      acc[formattedDate] = (acc[formattedDate] || 0) + Number(obj.valor)
      return acc
    }, getEmptyDatesObject(data))
  }

  const totalSum = (lista) => {
    return lista?.reduce((total, valorAtual) => total + valorAtual, 0)
  }

  const [paymentMethods, setPaymentMethods] = useState([])

  useEffect(() => {
    let methodCounts = {}

    salesData?.map((sale) => {
      sale.methods.map((method) => {
        methodCounts[method.nome] = (methodCounts[method.nome] || 0) + parseFloat(method.valor)
      })
    })

    const sortedMethods = Object.entries(methodCounts)
      .sort((a, b) => b[1] - a[1])
      .map(([nome, valor]) => [nome, valor])

    setPaymentMethods(sortedMethods)
  }, [salesData])

  const [topItems, setTopItems] = useState([])

  useEffect(() => {
    let itemCounts = {}

    salesData?.map((curr) => {
      curr.itens.map((item) => {
        itemCounts[item.nome] = (itemCounts[item.nome] || 0) + item.quantidade
      })
    })

    const sortedItems = Object.entries(itemCounts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5)
      .map(([nome, quantidade]) => [nome, quantidade])

    setTopItems(sortedItems)
    console.log(sortedItems)
  }, [salesData])

  function getEmptyDatesObject(data) {
    const emptyDatesObject = {}
    const startDate = getMinDate(data)
    const endDate = getMaxDate(data)
    const currentDate = new Date(startDate)

    while (currentDate <= endDate) {
      const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}/${(
        currentDate.getMonth() + 1
      )
        .toString()
        .padStart(2, '0')}/${currentDate.getFullYear()}`
      emptyDatesObject[formattedDate] = 0
      currentDate.setDate(currentDate.getDate() + 1)
    }

    return emptyDatesObject
  }

  function getMinDate(data) {
    return data?.reduce((minDate, obj) => {
      const currentDate = new Date(obj.data)
      return currentDate < minDate ? currentDate : minDate
    }, new Date())
  }

  function getMaxDate(data) {
    return data?.reduce((maxDate, obj) => {
      const currentDate = new Date(obj.data)
      return currentDate > maxDate ? currentDate : maxDate
    }, new Date())
  }

  useEffect(() => {
    const groupedData = groupByMonth(salesData, 2023)

    setData(groupedData)

    setTableSales(reduceSales(salesData))
  }, [isLoading])

  if (isLoading) return <div>LOADING</div>

  return (
    <Content>
      <Title>Relatório de vendas</Title>
      <GridLayout>
        <BoxShadow className={'item1'} radius={'5px'}>
          {/* <Actions>
            <Periods>
              <ButtonSubmit colorFont={'#000'} invert>
                Diário
              </ButtonSubmit>
              <ButtonSubmit colorFont={'#000'} invert>
                Mensal
              </ButtonSubmit>
              <ButtonSubmit colorFont={'#000'} invert>
                Anual
              </ButtonSubmit>
            </Periods>

            <PeriodSetDiv>
              <ButtonSubmit width={'38px'} invert>
                <HiOutlineChevronLeft />
              </ButtonSubmit>
              <input value={'Julho - 2023'} />
              <ButtonSubmit width={'38px'} invert>
                <HiOutlineChevronRight />
              </ButtonSubmit>
            </PeriodSetDiv>
          </Actions> */}
          <Container>
            <LineChart passedData={dataPassed} height={245} />

            {/* <StyledCSVLink data={data} headers={headers} filename={'relatorio-de-vendas.csv'}>
            Exportar
          </StyledCSVLink> */}
            {/* <div>
            <Table>
              <thead>
                <Tr>
                  {headers.map((header) => (
                    <Th key={header.key}>{header.label}</Th>
                  ))}
                </Tr>
              </thead>
              <tbody>
                {tableSales &&
                  Object.entries(tableSales)?.map(([date, value]) => {
                    return (
                      <Tr key={date}>
                        <Td>{date}</Td>
                        <Td>{Mask.money(value)}</Td>
                      </Tr>
                    )
                  })}
              </tbody>
            </Table>
          </div> */}
          </Container>
        </BoxShadow>

        <Infos className={'item1-1'}>
          <BoxShadow radius={'5px'}>
            <p>
              <TbChartInfographic />
            </p>
            <p>Vendas totais</p>
            <p>{Mask.money(totalSum(dataPassed.data))}</p>
          </BoxShadow>
          <BoxShadow radius={'5px'}>
            <p>
              <TbPigMoney />
            </p>
            <p>Lucro total</p>
            <p>R$720.821,00</p>
          </BoxShadow>
        </Infos>

        <BoxShadow radius={'5px'} padding={'7px'} className="item2">
          <p>Distribuição por forma de pagamento</p>
          <PieChart data={paymentMethods} series={'Valor'} />
          {/*
          <p>
            Ultimas vendas <button>Ver todos</button>
          </p>
          <Table>
            <thead>
              <tr>
                <th>Id</th>
                <th>Data</th>

                <th>Forma</th>
                <th>Valor</th>
                <th>Nota fiscal</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>44</td>
                <td>24/02/2123</td>

                <td>
                  {' '}
                  <ComponentItem
                    margin={'0px 2px'}
                    padding={'5px'}
                    height={'auto'}
                    title={'Pix'}
                  ></ComponentItem>
                </td>
                <td className="greenText">R$ 44,00</td>
                <td>
                  {' '}
                  <Tag green>
                    <AiOutlineCheckCircle />
                  </Tag>
                </td>
              </tr>
              <tr>
                <td>44</td>
                <td>24/02/2123</td>

                <td>
                  {' '}
                  <ComponentItem
                    margin={'0px 2px'}
                    padding={'5px'}
                    height={'auto'}
                    title={'Pix'}
                  ></ComponentItem>
                </td>
                <td className="greenText">R$ 44,00</td>
                <td>
                  {' '}
                  <Tag green>
                    <AiOutlineCheckCircle />
                  </Tag>
                </td>
              </tr>
              <tr>
                <td>44</td>
                <td>24/02/2123</td>

                <td>
                  {' '}
                  <ComponentItem
                    margin={'0px 2px'}
                    padding={'5px'}
                    height={'auto'}
                    title={'Pix'}
                  ></ComponentItem>
                </td>
                <td className="greenText">R$ 44,00</td>
                <td>
                  {' '}
                  <Tag green>
                    <AiOutlineCheckCircle />
                  </Tag>
                </td>
              </tr>
            </tbody>
          </Table> */}
        </BoxShadow>
        <BoxShadow radius={'5px'} padding={'7px'} className={'item3-1'}>
          <p>Relação Lucro x Despesa</p>
          <ColumnHighChart />
        </BoxShadow>
        <BoxShadow radius={'5px'} padding={'7px'} className={'item3'}>
          <p>Top 5 produtos mais vendidos</p>
          <PieChart title={'Top 5 produtos mais vendidos'} series={'Quantidade'} data={topItems} />
        </BoxShadow>
      </GridLayout>
    </Content>
  )
}

export default Report1
